import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAttendanceData = async ({
  companyCode,
  locationCode,
  fromDate,
  toDate,
  isAllCompanies = false,
  userId,
  selectedCompanyCode,
  status,
}) => {
  if (companyCode && locationCode) {
    let queryString = `?CompanyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}&AtndFromDate=${fromDate}&AtndToDate=${toDate}&IsAllCompanies=${isAllCompanies}`;

    if (status !== "") {
      queryString += `&Status=${status === "Present" ? 1 : status === "Absent" ? 0 : 0.5}`;
    }

    if (isAllCompanies && userId !== 0) {
      queryString += `&UserId=${userId}`;
    }

    const { data } = await http_payroll.get(
      `${Api_EndPoints.GetEmpAttendanceList}${queryString}`,
    );
    return data;
  }

  return [];
};

export const useGetEmpAttendanceFilterQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetEmpAttendanceList],
    queryFn: () => getAttendanceData(input),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
